import { useSearchParams } from 'react-router-dom'

import { Booking } from '../../models/Booking'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    booking: Booking
}

export const BookingCompletePage = ({ booking }: Props) => {
    const { onReset } = WorkflowPage.useResetContainerContext()
    const [searchParams] = useSearchParams()
    const didSend = searchParams.get('notify') === 'true'

    return (
        <div className="flex items-center justify-center">
            <div className="max-w-xlarge pt-12">
                <WorkflowPage.SuccessView
                    subtitle={
                        didSend
                            ? `The appointment was sent to ${booking.client?.name ?? 'your client'}`
                            : `The appointment with ${booking.client?.name ?? 'your client'} was saved`
                    }
                    links={[
                        {
                            id: 'create-another',
                            icon: 'plus.large',
                            title: 'Schedule another',
                            subtitle: 'Create an appointment',
                            onClick: onReset,
                        },
                        {
                            id: 'view',
                            icon: 'calendar.large',
                            title: 'View appointment',
                            subtitle: 'View this record',
                            to: `/bookings/${booking.id}`,
                        },
                        {
                            id: 'inbox',
                            icon: 'message.large',
                            title: 'Inbox',
                            subtitle: 'View your inbox',
                            to: '/messages',
                        },
                        {
                            id: 'calendar',
                            icon: 'calendar.large',
                            title: 'Calendar',
                            subtitle: 'View your calendar',
                            to: '/calendar',
                        },
                        {
                            id: 'dashboard',
                            icon: 'home.large',
                            title: 'Dashboard',
                            subtitle: 'View home screen',
                            to: '/',
                        },
                    ]}
                />
            </div>
        </div>
    )
}
